import axiosClient from "./axiosClient";

// Mốc thời gian xếp đơn vào một ngày: ngày ĐẶT đơn vs ngày sàn DUYỆT đơn.
export type TimeField = "purchase" | "complete";

const analyticsApi = {
    // Returns [{date, totalCommission, totalUserCommission}] grouped by day.
    // timeField: 'purchase' (ngày đặt đơn, mặc định) | 'complete' (ngày sàn duyệt)
    getDaily(days = 30, timeField: TimeField = "purchase") {
        return axiosClient.get(`/analytics/daily?days=${days}&timeField=${timeField}`);
    },
    // Returns {timeField, totalCommission, totalUserCommission, totalOrders,
    // pendingOrders, pendingCommission, totalPaid, pendingPayments, platforms}
    getSummary(params?: { startDate?: number; endDate?: number; timeField?: TimeField }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null)
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.get(`/analytics/summary${qs ? "?" + qs : ""}`);
    },
    // Lịch sử số liệu đã snapshot. Trả [{stat_date, platform, orders, commission,
    // user_commission, clicks, new_users, withdraw_count, withdraw_amount}]
    getDailyStats(params?: {
        from?: string;
        to?: string;
        platform?: string;
        limit?: number;
    }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.get(`/analytics/daily-stats${qs ? "?" + qs : ""}`);
    },
    // Lịch sử số liệu theo TỪNG TÀI KHOẢN cookie (DailyStatAccounts). Trả [{stat_date,
    // cookie_platform, camp_id, orders, commission, user_commission, orders_pending,
    // orders_cancelled, buff_orders, buff_commission}]
    getAccountDailyStats(params?: {
        from?: string;
        to?: string;
        account?: string;
        limit?: number;
    }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.get(`/analytics/account-daily-stats${qs ? "?" + qs : ""}`);
    },
    // Chạy snapshot thủ công. Bỏ trống = hôm qua; {date} = 1 ngày; {from,to} = backfill khoảng.
    runDailyStatsSnapshot(params?: { date?: string; from?: string; to?: string }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.post(`/analytics/daily-stats/snapshot${qs ? "?" + qs : ""}`);
    },

    // Chỉ số GROWTH APP đã chụp (bảng AppGrowthStats), mới nhất trước.
    // Ống kính thời gian KHÁC các hàm trên: growth xếp đơn theo purchaseTime
    // (ngày user đặt đơn), không phải completeTime (ngày sàn duyệt).
    getAppGrowthStats(params?: { from?: string; to?: string; limit?: number }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.get(`/analytics/app-growth${qs ? "?" + qs : ""}`);
    },
    // Số liệu ĐẦU PHỄU từ hệ thống ngoài (App Store Connect / Google Play / Firebase).
    // Trả { rows, syncState } — syncState để biết nguồn nào chưa cấu hình / đang hỏng.
    // ⚠️ stat_date ở đây KHÁC quy chiếu với getAppGrowthStats: appstore theo UTC,
    // play theo giờ Thái Bình Dương, còn AppGrowthStats theo ngày VN. Đừng ghép thẳng.
    getAppGrowthExternal(params?: { from?: string; to?: string; source?: string }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.get(`/analytics/app-growth/external${qs ? "?" + qs : ""}`);
    },
    // Chụp lại growth. Bỏ trống = 8 ngày gần nhất (đúng lượt cron); {date} = 1 ngày;
    // {from,to} = backfill khoảng. Query nặng — đừng bấm liên tục.
    runAppGrowthSnapshot(params?: { date?: string; from?: string; to?: string }) {
        const entries = params
            ? Object.entries(params).filter(([, v]) => v != null && v !== "")
            : [];
        const qs = entries.map(([k, v]) => `${k}=${v}`).join("&");
        return axiosClient.post(`/analytics/app-growth/snapshot${qs ? "?" + qs : ""}`);
    },
};

export default analyticsApi;
